import React from 'react';
import { Helmet } from 'react-helmet';

const SITE_NAME = 'Ziyad Attorneys';
const SOCIAL_IMAGE = 'https://ziyadattorneys.com/bigrum.jpg';

function SeoMeta({ title, description }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={SOCIAL_IMAGE} />
      <meta property="og:image:width" content="1280" />
      <meta property="og:image:height" content="720" />
      <meta property="og:image:alt" content="Ziyad Attorneys in Ethiopia" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={SOCIAL_IMAGE} />
      <meta name="twitter:image:alt" content="Ziyad Attorneys in Ethiopia" />
    </Helmet>
  );
}

export default SeoMeta;
